/* eslint-disable react/require-default-props */
import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ComponentPlaceholder } from '@thd-olt-component-react/loading-placeholder';

const HdhomeSignupPlaceholder = ({ color = '#E0E0E0', showLoadingAnimation = false }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  return (
    <ComponentPlaceholder
      height={isMobile ? 130 : 75}
      rows={isMobile ? 4 : 3}
      color={color}
      showLoadingAnimation={showLoadingAnimation}
    />
  );
};

HdhomeSignupPlaceholder.propTypes = {
  color: string,
  showLoadingAnimation: bool
};

export { HdhomeSignupPlaceholder };